import React from "react";

type TagComponentProps = {
  text: string;
  size?: "lg" | "sm" | undefined;
  active?: boolean;
  corners?: "full-rounded" | "rounded" | "square" | undefined; 
  type?: "primary" | "secondary" | undefined;
}

export default class Tag extends React.Component<TagComponentProps> { 
  render() {
    const size = this.props.size || "md";
    const active = this.props.active === true ? 'active' : '';
    const text = (this.props.text || "").substring(0, 16);
    const append = (this.props.text || "").length > 16 ? '...' : '';
    const tagtext = text + append;
    const type = this.props.type || "primary";
    const corners = this.props.corners || "full-rounded";

    const cornerClasses = {
      'full-rounded': 'rounded-full',
      'rounded': 'rounded-lg',
      'square': ''
    }[corners];

    return (
      <div className={`
        ${cornerClasses} px-3 py-1.5 
        caption 
        tag-size-${size} 
        ${active} 
        border
        ${type === 'primary' 
          ? 'bg-[color:var(--tag-color)] text-[color:var(--text-color)] border-[color:var(--tag-color)]'
          : 'bg-transparent text-[color:var(--tag-color)] border-[color:var(--tag-color)]'
        }
      `}>
        {tagtext}
      </div>
    );
  }
}